import React, { Component } from 'react';
import PropTypes from 'prop-types';

const SaveBtn = ({
  toggleFavorite,
  buttonClass = '',
  isFav,
  text,
  favoriteCount,
  hideCount,
  isFetching
}) => {
  // console.log('isFetching', isFetching);
  const heartClass = isFav ? 'icon-full-heart-plus' : 'icon-empty-heart-plus';
  let favoriteText = 'Be the first to save this space';
  if (0 < favoriteCount) {
    favoriteText = `${favoriteCount} people have saved this space`;
  }
  return (
    <div>
      <button
        onClick={toggleFavorite}
        id="favorites-btn"
        className={`btn btn-default favorites-btn flex center ${buttonClass}`}
        type="button"
        name="button"
        disabled={isFetching}
      >
        <i className={heartClass} />
        <span>{ text }</span>
      </button>
      {
        hideCount ? '' :
          <p className="text-gray-dark text-small text-center"> { favoriteText } </p>
      }
    </div>
  );
};

const SaveIcon = ({
  toggleFavorite,
  isFav,
  text,
  buttonClass
}) => {
  const heartClass = isFav ? 'icon-full-heart-plus' : 'icon-empty-heart-plus';
  return (
    <button className={`btn fav-heart favorites-icon ${buttonClass}`} onClick={toggleFavorite}>
      <i className={`ico ico-md ${heartClass} right`} />
      <span>{text}</span>
    </button>
  );
};

export class ProjectsSaveMain extends Component {
  render () {
    const {
      isButton,
      isFav,
      favoriteText = 'Save',
      unFavoriteText = 'Save',
      favoriteCount,
      hideCount,
      buttonClass,
      actionFn,
      isFetching
    } = this.props;
    const favoriteProps = {
      isFav,
      toggleFavorite: actionFn,
      text: isFav ? favoriteText : unFavoriteText,
      buttonClass,
      favoriteCount,
      hideCount,
      isFetching
    };
    return (
      <div className="projects-save-btn-container">
        { isButton ? <SaveBtn {...favoriteProps} /> : <SaveIcon {...favoriteProps} /> }
      </div>
    );
  }
}

SaveBtn.propTypes = {
  toggleFavorite: PropTypes.func,
  buttonClass: PropTypes.string,
  isFav: PropTypes.bool,
  text: PropTypes.string,
  favoriteCount: PropTypes.number,
  hideCount: PropTypes.number,
  isFetching: PropTypes.bool
};

SaveIcon.propTypes = {
  toggleFavorite: PropTypes.func,
  buttonClass: PropTypes.string,
  isFav: PropTypes.bool,
  text: PropTypes.string
};

ProjectsSaveMain.propTypes = {
  hideCount: PropTypes.bool,
  isFetching: PropTypes.bool,
  isFav: PropTypes.bool,
  favoriteCount: PropTypes.number,
  favoriteText: PropTypes.string,
  unFavoriteText: PropTypes.string,
  buttonClass: PropTypes.string,
  listing: PropTypes.object.isRequired,
  isButton: PropTypes.bool,
  actionFn: PropTypes.func,
  gaID: PropTypes.string,
  whichFavoriteBtn: PropTypes.string
};
